import React from 'react'
import './style/Drawer.css'

function Drawer({drawer, fn}) {
    return (
        <div className="drawer" style={{ transform: `translateX(${drawer}px)` }}>
            <ul  onClick={fn}>
                    <li> <a href="#home">Home</a> </li>
                    <li><a href="#about">About Us</a></li>
                    <li><a href="#service">Service</a></li>
                    <li><a href="#portfolio">Portfolio</a></li>
                    <li><a href="#pricing">Pricing</a></li>
                    <li><a href="#contact">Contact Us</a></li>
                </ul>
        </div>
    )
}

export default Drawer
